;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useContext } from 'react';
import { AnnouncementContext } from './consts';
export const useAnnouncement = () => {
  return useContext(AnnouncementContext);
};